/**
 * 新版教务系统（EAS）地址
 *
 * 开发环境跳内网开发实例，其余环境（测试 / 生产）跳生产地址。
 * 登录页和 layout 顶部的「体验新EAS」入口共用这里的地址。
 */
export const EAS_BASE_URL =
  process.env.NODE_ENV === "development"
    ? "http://10.126.126.10:9527"
    : "https://eas.houbaoyan.cn";

/** 新系统登录页 */
export const EAS_LOGIN_URL = `${EAS_BASE_URL}/login`;
